import React from 'react';

import { getUserInitials } from '../../../utils/initialName';

import { CartIcon, UserIcon, ChevronRightIcon } from '../../../assets/icons';

const HeaderNav = ({ baseURL, isAuthenticated, isMobile, user }) => {
  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div>
      <div className="logged_in_header">
        <div className="avatar_user_large">{getUserInitials(user.username)}</div>
        <div className="logged_in_header_text">
          <p>
            Olá, <strong>{user.name}</strong>!
          </p>
        </div>
      </div>
      {isMobile ? (
        <nav className="nav_menu">
          <ul className="nav_menu_items">
            <li className="items">
              <a href={`${process.env.REACT_APP_SITE_URL}/area-do-cliente/`} className="dropdown_item">
                Ver minha conta
                <ChevronRightIcon size={24} color="#007E47" />
              </a>
            </li>
          </ul>
        </nav>
      ) : (
        <nav className="nav_menu">
          <ul className="nav_menu_items">
            <li className="items">
              <a href={`${baseURL}/area-do-cliente/meu-perfil`} className="dropdown_item">
                <UserIcon size={24} color="#007E47" />
                Ver minha conta
              </a>
            </li>
            <li className="items">
              <a href={`${baseURL}/area-do-cliente/meus-pedidos`} className="dropdown_item">
                <CartIcon size={24} color="#007E47" />
                Meus pedidos
              </a>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/trigger_auth/headerNav/HeaderNav.jsx